<template>
    <div>
        <div class="full-width-grid intro-background margin--l-xl">
            <div class="grid-wrapper">
                <div class="intro__content">
                    <h1 class="black-primary">
                        {{ printString('loading') }}
                    </h1>
                </div>
            </div>

            <div class="intro-gradient">
                <div class="intro-gradient__red"></div>
                <div class="intro-gradient__yellow"></div>
                <div class="intro-gradient__white"></div>
                <div class="intro-gradient__white"></div>
            </div>
        </div>
        <div class="grid-wrapper margin--2xl-3xl">
            <div class="loading__container"></div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'LoadingIntro',
    methods: {
        printString(string) {
            return window.translations[string];
        },
    }
}
</script>